















































import { Component, Vue } from 'vue-property-decorator'
import UserModule from '@api/module/customer/user/UserModule'
import { TeachUnit } from '@api/model/basic-data/TeachUnit'
import HomeModule from '@api/module/customer/basic-data/BasicDataModule'
import CurrentSchemeModule from '@/center/store/learningscheme/CurrentSchemeModule'
import HbSystemEventLogRequest from '@/components/system-event-logs/requests.vue'
import DevToolsModule from '@/common/store/DevToolsModule'
import CenterModule from '@/center/store/home/HomeModule'
@Component({
  components: {
    HbSystemEventLogRequest
  }
})
export default class extends Vue {
  isDev = process.env.NODE_ENV === 'development'
  showErrors = false
  get userPhoto() {
    return UserModule.getUserPhotoUrl
  }

  get userInfo() {
    return UserModule.userInfo
  }
  get currentUnit() {
    return HomeModule.currentUnit || new TeachUnit()
  }

  get maxTipCount() {
    return DevToolsModule.maxTipCount
  }

  get receiveCount() {
    return DevToolsModule.receiveCount
  }

  get showAdminName(): boolean {
    return CenterModule.showAdminName
  }

  toggleErrorDialog() {
    this.showErrors = !this.showErrors
    if (this.showErrors) {
      DevToolsModule.clearReceiveCount()
    }
  }

  clickLogin() {
    this.$confirm('你确定退出学习？', '', {
      distinguishCancelAndClose: true,
      confirmButtonText: '确认退出',
      cancelButtonText: '取消'
    }).then(async () => {
      await this.$authentication.logout()
      await UserModule.doEXitLogin()
      // this.$router.replace('/')
      location.replace('/')
      await CurrentSchemeModule.rest()
      this.$message({
        message: '登出成功',
        type: 'success'
      })
    })
  }
}
